import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvConsultationChecklistImageLineModel } from '../../../../../models/aggregates/asv/asv-consultation-checklist-image-line.model';
import {BaseApiTemplateService, Core2Config} from '../../api-services';
import {BasicApiResponseModel } from '../shared/api-response.model';

import { ApiVisa } from '../shared/api-visa.model';

@Injectable({
  providedIn: 'root'
})
export class AsvConsultationChecklistImageLineService extends BaseApiTemplateService<AsvConsultationChecklistImageLineModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'consultation-checklist-image-lines';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-checklist-image-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-checklist-image-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
      }

    addImageHdrIsPublic(formData: FormData, hdrGuid: string, type: string, visa: ApiVisa, imagePublic: boolean = false) {
      if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      // Use backticks for template literals
      const url = `${this.apiUrl}/add-images/${hdrGuid}?is_public=${imagePublic}&type=${type}`;
      return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  replaceImageHdrIsPublic(formData: FormData, lineGuid: string, visa: ApiVisa, imagePublic: boolean = false) {
    if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = `${this.apiUrl}/replace-images/${lineGuid}?is_public=${imagePublic}`;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  public editCarConditionPromise(
    dtoObject: AsvConsultationChecklistImageLineModel,
    visa: ApiVisa
  ): Promise<BasicApiResponseModel<AsvConsultationChecklistImageLineModel>> {
    return this.httpClient.put<BasicApiResponseModel<AsvConsultationChecklistImageLineModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  getImageHdrCarConditionFile(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/image-file/' + imageHdrGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  deleteImageHdrCarConditionFile(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/image-file/' + imageHdrGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }
  
  
  
}
